<template>
  <el-row>
    <el-col :span="24">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home" />首页
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Organization' }">创新平台</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="wrap">
        <div class="countent">
          <div class="head_box" v-if="$route.query.type !== '3' && $route.query.type !== '4'">
            <div class="img_box">
              <img v-if="$route.query.type == '1'" :src="pageData.Logo" alt />
              <img v-if="$route.query.type == '2'" :src="pageData.Field1" alt />
            </div>
            <div class="text_box">
              <p class="title">{{ pageData.UnitName }}</p>
              <!-- <p>{{ pageData.Address }}</p> -->
              <div class="address_post">
                <p>
                  <span>
                    <img src="../../../assets/library/地址.png" alt />
                    地址：
                  </span>
                  <span v-html="pageData.Address"></span>
                </p>
                <p>
                  <span>
                    <img src="../../../assets/library/信封邮件.png" alt />
                    邮编：
                  </span>
                  <span>{{ pageData.PostalCode || pageData.PostCode }}</span>
                </p>
              </div>
              <div class="info_box">
                <div class="info">
                  <p>
                    <span>单位性质：</span>
                    <span>{{ pageData.Field7 || pageData.UnitType }}</span>
                  </p>
                  <p>
                    <span>注册资金(万元)：</span>
                    <span>{{ pageData.RegisteredCapital }}</span>
                  </p>
                </div>
                <div class="info">
                  <p>
                    <span>注册年份：</span>
                    <span>
                      {{
                      pageData.RegistrationTime || pageData.DeclarationTime
                      }}
                    </span>
                  </p>
                  <p>
                    <span>备案年份：</span>
                    <span>
                      {{
                      pageData.ApplicationDate || pageData.DateIncorporation
                      }}
                    </span>
                  </p>
                </div>
                <p>
                  <span>研发类型：</span>
                  <span>{{ pageData.RDType }}</span>
                </p>
                <p style="max-width: 28.625rem">
                  <span>技术领域：</span>
                  <span>{{ pageData.TechnicalField }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="head_box_union" v-if="$route.query.type == '3'">
            <div class="img_box">
              <img :src="pageData.Field1" alt />
            </div>
            <div class="text_box">
              <p class="title">{{ pageData.Title }}</p>
              <!-- <p>{{ pageData.Address }}</p> -->
              <div class="address_post">
                <p>
                  <span>
                    <img src="../../../assets/library/地址.png" alt />
                    地址：
                  </span>
                  <span>{{ pageData.Address }}</span>
                </p>
                <p>
                  <span>
                    <img src="../../../assets/library/信封邮件.png" alt />
                    邮编：
                  </span>
                  <span>{{ pageData.PostCode }}</span>
                </p>
              </div>
              <div class="info_box">
                <div class="info">
                  <p>
                    <span>牵头单位：</span>
                    <span>{{ pageData.LeadingUnit }}</span>
                  </p>
                  <p>
                    <span>牵头单位性质：</span>
                    <span>{{ pageData.UnitNature }}</span>
                  </p>
                </div>
                <div class="info">
                  <p>
                    <span>注册年份：</span>
                    <span>{{ pageData.RegistrationTime }}</span>
                  </p>
                  <p>
                    <span>备案年份：</span>
                    <span>{{ pageData.FillingDate }}</span>
                  </p>
                </div>
                <p>
                  <span>技术领域：</span>
                  <span>{{ pageData.TechnicalField }}</span>
                </p>
                <p>
                  <span>联盟成员数：</span>
                  <span>{{ pageData.LmTotal }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="head_box_union" v-if="$route.query.type == '4'">
            <div class="img_box">
              <img :src="pageData.Logo" alt />
            </div>
            <div class="text_box">
              <p class="title">{{ pageData.CNTitle }}({{ pageData.ENTitle }})</p>
              <!-- <p>{{ pageData.Address }}</p> -->
            </div>
          </div>
          <div class="detail_box">
            <div class="compony">
              <p class="head">
                <img src="../../../assets/library/组 4238.png" alt />
                <span>单位介绍</span>
              </p>
              <el-divider style="margin: 0.9375rem 0"></el-divider>
              <p
                v-if="$route.query.type == '1'"
                class="content"
                v-html="pageData.OrganizationProfile"
              ></p>
              <p v-if="$route.query.type == '2'" class="content" v-html="pageData.Jszygzms"></p>
              <p v-if="$route.query.type == '3'" class="content" v-html="pageData.Lmbj"></p>
              <p v-if="$route.query.type == '4'" class="content" v-html="pageData.Convent"></p>
              <Empty
                v-if="
                  pageData.OrganizationProfile == '' ||
                  pageData.Jszygzms == '' ||
                  pageData.Lmbj == '' ||
                  pageData.Convent == ''
                "
              />
            </div>
            <div class="compony">
              <p class="head">
                <img src="../../../assets/library/组 23386.png" alt />
                <span>技术需求</span>
              </p>
              <el-divider style="margin: 0.9375rem 0"></el-divider>
              <div v-if="needData.length > 0">
                <div v-for="(i, index) in needData" class="titlecontent" :key="index">
                  <span
                    @click="rightabout(i.ID)"
                    style="cursor: pointer"
                  >{{ index + 1 }}. {{ i.Title }}</span>
                </div>
              </div>
              <Empty v-else />
            </div>
            <div class="compony">
              <p class="head">
                <img src="../../../assets/library/组 23387.png" alt />
                <span>技术成果</span>
              </p>
              <el-divider style="margin: 0.9375rem 0"></el-divider>
              <div v-if="achieveData.length > 0">
                <div v-for="(i, index) in achieveData" :key="index" class="titlecontent">
                  <span
                    @click="rightachievement(i.ID)"
                    style="cursor: pointer"
                  >{{ index + 1 }}. {{ i.Title }}</span>
                </div>
              </div>
              <Empty v-else />
            </div>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { getAction, postAction } from '@/api/api'
import qs from 'qs'
import { organPool } from '@/api/url'
import Empty from '../../../components/empty.vue'
export default {
  name: '',
  data() {
    return {
      pageData: {},
      needData: [],
      achieveData: [],
    }
  },
  props: {},
  components: { Empty },
  mounted() {
    //// console.log(this.$route.query);
    if (this.$route.query.type === '1') {
      //// console.log(this.$route.query.type);
      this.getDetail('Get_OrganizationInfo') //新型研发机构详情
    } else if (this.$route.query.type === '2') {
      //// console.log(this.$route.query.type);
      this.getDetail('Get_TechnologyOrganizationInfo') //技术转移示范机构详情
    } else if (this.$route.query.type === '3') {
      //// console.log(this.$route.query.type);
      this.getDetail('Get_UnionInfo') //技术转移联盟详情
    } else if (this.$route.query.type === '4') {
      //// console.log(this.$route.query.type);
      this.getDetail('Get_InternationalInfo') //
    }
  },
  methods: {
    rightabout(a) {
      this.$router.push({
        path: '/demandDetail',
        query: {
          id: a,
        },
      })
    },
    rightachievement(a) {
      this.$router.push({
        path: '/fruitDetail',
        query: {
          id: a,
        },
      })
    },
    getDetail(a) {
      //// console.log("aaaaaaaaa",a)
      let data = {
        action: a,
        id: this.$route.query.id,
      }
      //// console.log(data, "1231231231");
      postAction(organPool, qs.stringify(data)).then((res) => {
        //// console.log(res, "!!!!!!!!!!!!!!!!!!!!!");
        if (res) {
          this.pageData = res
          
          if (this.$route.query.type === '1') {
            this.getNeeddata(res.UnitName)
            this.getAchieve(res.UnitName)
          } else if (this.$route.query.type === '2') {
            this.getNeeddata(res.UnitName)
            
            this.getAchieve(res.UnitName)
          } else if (this.$route.query.type === '3') {
            this.getNeeddata(res.Title)
            this.getAchieve(res.Title)
          } else if (this.$route.query.type === '4') {
            this.getNeeddata(res.CNTitle)
            this.getAchieve(res.CNTitle)
          }
        }
      })
    },
    getNeeddata(a) {
      let data = {
        action: 'Get_OrganizationDemand',
        Title: a,
      }
      postAction(organPool, qs.stringify(data)).then((res) => {
        //// console.log(res);
        if (res) {
          this.needData = res
          //// console.log(this.needData);
    
        }
      })
    },
    getAchieve(a) {
      let data = {
        action: 'Get_OrganizationAchievements',
        Title: a,
      }
      postAction(organPool, qs.stringify(data)).then((res) => {
        //// console.log(res);
        if (res) {
          this.achieveData = res
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-breadcrumb {
  width: 86.25rem;
  margin: 0 auto;
  padding: 1.25rem;
  color: #999999;
}
.wrap {
  width: 87.5rem;
  background: #ffffff;
  box-shadow: 0rem 0rem 0.9375rem rgba(0, 0, 0, 0.06);
  opacity: 1;
  border-radius: 0rem;
  margin: 0 auto;
}
.countent {
  padding: 1.875rem 2.1875rem;
}
.head_box {
  display: flex;
  flex-direction: row;
  .img_box {
    width: 26.25rem;
    height: 14.125rem;
    img {
      width: 100%;
      vertical-align: baseline;
    }
  }
  .text_box {
    margin-left: 2.5rem;
    display: flex;
    flex-direction: column;
    text-align: left;
    .title {
      font-size: 1.625rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      opacity: 1;
    }
    .address_post {
      display: flex;
      justify-content: space-between;
      margin-top: 0.875rem;
      margin-bottom: 1.875rem;
      p {
        min-width: 70%;
        /* width: 17.5rem; */
        margin-right: 1.5625rem;
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        opacity: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        span {
          img {
            vertical-align: middle;
          }
        }
      }
    }
    .info_box {
      display: flex;
      flex-direction: column;
      text-align: left;
      .info {
        display: flex;
        justify-content: space-between;
      }
      p {
        font-size: 1rem;
        max-width: 14.625rem;
        min-width: 14.625rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        opacity: 1;
        margin-bottom: 0.875rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.head_box_union {
  display: flex;
  flex-direction: row;
  .img_box {
    width: 26.25rem;
    height: 14.125rem;
    img {
      width: 100%;
      vertical-align: baseline;
    }
  }
  .text_box {
    max-width: 53.75rem;
    margin-left: 2.5rem;
    display: flex;
    flex-direction: column;
    text-align: left;
    .title {
      font-size: 1.625rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      opacity: 1;
    }
    .address_post {
      display: flex;
      justify-content: space-between;
      margin-top: 0.875rem;
      margin-bottom: 1.875rem;
      p {
        min-width: 70%;
        margin-right: 1.5625rem;
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 0rem;
        color: #666666;
        opacity: 1;
        white-space: nowrap;
        overflow: hidden;
        
        text-overflow: ellipsis;
        span {
          img {
            vertical-align: middle;
          }
        }
      }
    }
    .info_box {
      display: flex;
      flex-direction: column;
      text-align: left;
      .info {
        display: flex;
        justify-content: space-between;
      }
      p {
        // width: 50%;
        font-size: 1rem;
        min-width: 10.625rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        opacity: 1;
        margin-bottom: 0.875rem;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
      }
    }
  }
}
.detail_box {
  margin-top: 2.3125rem;
  .compony {
    margin-bottom: 2.3125rem;
    .head {
      text-align: left;
      img {
        width: 2rem;
        height: 2rem;
        vertical-align: top;
      }
      span {
        margin-left: 0.25rem;
        font-size: 1.75rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 2rem;
        color: #333333;
      
        opacity: 1;
      }
    }
    .content {
      font-size: 1.125rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 2rem;
      color: #4a4a4a;
      opacity: 1;
      text-align: left;
    }
  }
}
.titlecontent {
  text-align: left;
  line-height: 3rem;
  font-size: 1.125rem;
  color: #4a4a4a;
}
.titlecontent span:hover {
  color: #308bec;
}
</style>